import { render, staticRenderFns } from "./cart-gift-note.vue?vue&type=template&id=4c0c3021&"
import script from "./cart-gift-note.vue?vue&type=script&lang=js&"
export * from "./cart-gift-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports